<template>
  <video class="modal__video" controls autoplay muted>
    <source :src="content">
  </video>
</template>

<script>
import { HasContentMixin } from '@/mixins'

export default {
  name: 'VideoModal',
  mixins: [HasContentMixin],
}
</script>